import React from "react";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";

import styles from "./closing.module.css";

const Closing = ({ content }) => {
  return (
    <div className={styles.closing}>
      <p>{content.closing}</p>
      <p>Mitsubishi, Pasti Sardana!</p>
      <div className={styles.button} onClick={() => window.location.reload()}>
        <HomeRoundedIcon />
      </div>
    </div>
  );
};

export default Closing;
